export const SET_PACKAGE_COUNT = 'SET_PACKAGE_COUNT';
export const ADD_PACKAGE = 'ADD_PACKAGE';
export const REMOVE_PACKAGE = 'REMOVE_PACKAGE';
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const RESET_PACKAGE = 'RESET_PACKAGE';
export const SET_INITIAL_PACKAGES = 'SET_INITIAL_PACKAGES';
export const SET_REFERENCE_PACKAGES = 'SET_REFERENCE_PACKAGES';
export const SET_PACKAGE_DIMENSION_UNIT = 'SET_PACKAGE_DIMENSION_UNIT';
export const RESET_PACKAGE_DIMENSIONS = 'RESET_PACKAGE_DIMENSIONS';
export const SET_EDIT_PACKAGE_BTN = 'SET_EDIT_PACKAGE_BTN';
